//导航栏功能
$(".hr_nav").hover(function(){
    var index =$(this).index(),tfX;
    if(index==0){
        tfX = '121%'
    }else if(index==1){
        tfX = '221%'
    }else if(index==2){
        tfX = '319%'
    }else if(index==3){
        tfX = '418%'
    }
    $(this).css({color:'black'}).siblings().css({color:'white'})
    $('.hr_mask').css({transform:`translate(${tfX})`})
    if(index==1) return;
    $('.main_mask').css({height:'100vh'})
    $(`.hm_popup${index+1}`).css({height:eval(`$('.hm_popup${index+1}')[0].scrollHeight`)})
},function(){
    var index =$(this).index();
    if(index==1) return;
    $('.main_mask').css({height:'0'})
    $(`.hm_popup${index+1}`).css({"height":"0"})
}) 

$(".hm_popup").hover(function(){
    var index = $(this).index()+1
    $('.main_mask').css({height:'100vh'})
    $(this).css({height:eval(`$('.hm_popup${index}')[0].scrollHeight`)})
},function(){
    $(this).css({height:'0'})
    $('.main_mask').css({height:'0'})
})

var lastScrollTop = 0,wFlag=window.innerWidth>750,productPage = false
$(function () {
    if (document.querySelector('.product_nav')) {
        productPage = true
    }
})
$(window).scroll(function(){
    var Top = $(window).scrollTop()
    if(Top>55){
        $('.header_main').css({position:'fixed',top:wFlag?'1.5%':'0'})
        if(wFlag){
            $('.hm_popups').css({top:'-1%'})
        }
    }else{
        $('.header_main').css({position:'absolute',top:wFlag?'130%':'100%'})
        if(wFlag){
            $('.hm_popups').css({top:'3rem'})
        }
    }
    if(productPage){
        if(Top > 84){
            //product header
            if(wFlag){
                $('.header_main').css({opacity:0})
            }
            $('.product_nav').css({ top: '0', transition: 'all 1s' })
            $('.Mproduct_nav').css({ top: '0', transition: 'all 1s' })
    
        }else{
            if(wFlag){
                $('.header_main').css({opacity:1})
            }
            $('.product_nav').css({ top: '-3.5rem', transition: 'none' })
            $('.Mproduct_nav').css({ top: '-3.5rem', transition: 'none' })
        }
    }
    if (Top < lastScrollTop) {
        // 鼠标向上滑动
        if(wFlag){
            $('.header_main').removeClass('headerActive')
        }
        if(Top>1){
            $('.To_top').fadeIn()
        }else{
            $('.To_top').fadeOut();
        }
    }else{
      $('.To_top').fadeOut();
      if(wFlag && Top>155){
        $('.header_main').addClass('headerActive')
      }
    }
    lastScrollTop = Top;
})


//Mobile
var mliflag = true;
$('.menu_left').click(function(){
    if(mliflag){
        $('.menu_line').css({background:'transparent'})
        $(this).addClass('menu_active')
        $('.Mhm_popup').css({height:'96vh'})
    }else{
        $('.menu_line').css({background:'white'})
        $(this).removeClass('menu_active')
        $('.Mhm_popup').css({height:'0'})
    }
    mliflag = !mliflag
})

$('.Mhm_popup .mp_item').click(function(){
    var Hmheight = $(this).next('.mp_content').css('height')
    if(Hmheight == '0px'){
        $(this).children('img').css({transform:'rotate(90deg)'})
        $(this).next('.mp_content').css({height:eval(`$(this).next('.mp_content')[0].scrollHeight`)})
    }else{
        $(this).children('img').css({transform:'rotate(0)'})
        $(this).next('.mp_content').css({height:'0'})
    }
})